"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.008.125H2.99a.743.743 0 0 0-.742.742v.258H13.75v13.172l-4.878-4.053a.5.5 0 0 0-.635-.002l-4.99 4.078V2.552h-1v12.823a.502.502 0 0 0 .818.387l5.485-4.485 5.38 4.47a.502.502 0 0 0 .82-.385V.867a.743.743 0 0 0-.742-.742"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.768.02H3.71a.938.938 0 0 0-.937.936v.188H20.58V22.2l-7.898-6.562a.562.562 0 0 0-.715-.003l-8.069 6.596V2.725H2.773v20.693a.562.562 0 0 0 .918.436l8.63-7.055 8.462 7.032a.562.562 0 0 0 .922-.433V.956a.938.938 0 0 0-.937-.937"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.691.026H4.947a1.25 1.25 0 0 0-1.249 1.249v.25H27.44V29.6l-10.53-8.75a.75.75 0 0 0-.954-.003L5.198 29.642V3.632h-1.5v27.592a.75.75 0 0 0 1.224.58L16.427 22.4l11.284 9.376a.75.75 0 0 0 1.23-.577V1.275c0-.688-.562-1.25-1.25-1.25"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.087.188H6.913a1.69 1.69 0 0 0-1.687 1.687v.188h35.673v42.775L24.767 31.433a.938.938 0 0 0-1.193-.004L7.101 44.897V4.704H5.226v42.171a.936.936 0 0 0 1.53.726l17.407-14.232 17.075 14.188a.937.937 0 0 0 1.537-.721V1.875A1.69 1.69 0 0 0 41.087.187"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.782.25H9.217a2.252 2.252 0 0 0-2.25 2.25v.25h47.565v57.034l-21.51-17.873a1.25 1.25 0 0 0-1.59-.006L9.467 59.863V6.272h-2.5V62.5a1.248 1.248 0 0 0 2.041.968l23.21-18.976L54.982 63.41a1.25 1.25 0 0 0 2.049-.962V2.5a2.252 2.252 0 0 0-2.25-2.25"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBookmark = function IconBookmark(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Bookmark' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Bookmark"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBookmark.sizes = [16, 24, 32, 48, 64];
IconBookmark.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBookmark;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Bookmark.js
// module id = 1669
// module chunks = 0